/**
 * Neutral shimmer skeleton shown while the geo API resolves (~50-150ms on
 * first visit). Matches the rough layout of the Hero component so there is
 * no layout shift when real content replaces it.
 */
const shimmer = {
    background:
        "linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%)",
    backgroundSize: "200% 100%",
    animation: "heroSkeletonShimmer 1.2s infinite",
    borderRadius: "0.5rem",
};

export default function HeroSkeleton() {
    return (
        <>
            <style>{`
                @keyframes heroSkeletonShimmer {
                    0%   { background-position: 200% 0; }
                    100% { background-position: -200% 0; }
                }
            `}</style>

            <section
                className="relative pb-20 overflow-hidden pt-32 sm:pt-40"
                aria-hidden="true"
            >
                <div className="max-w-7xl mx-auto px-4 sm:px-8 grid lg:grid-cols-12 gap-10 items-center">
                    {/* Left column skeleton */}
                    <div className="lg:col-span-7 space-y-5">
                        {/* Badge */}
                        <div style={{ ...shimmer, height: 32, width: 280 }} />
                        {/* Headline line 1 */}
                        <div style={{ ...shimmer, height: 60, width: "70%" }} />
                        {/* Headline line 2 */}
                        <div style={{ ...shimmer, height: 60, width: "90%" }} />
                        {/* Headline line 3 */}
                        <div style={{ ...shimmer, height: 60, width: "55%" }} />
                        {/* Subheadline */}
                        <div style={{ ...shimmer, height: 22, width: "95%", marginTop: 8 }} />
                        <div style={{ ...shimmer, height: 22, width: "80%" }} />
                        {/* CTA buttons */}
                        <div className="flex gap-3 mt-4">
                            <div style={{ ...shimmer, height: 52, width: 180 }} />
                            <div style={{ ...shimmer, height: 52, width: 160 }} />
                        </div>
                        {/* Credibility banner */}
                        <div style={{ ...shimmer, height: 44, width: 340, marginTop: 8 }} />
                        {/* Meta row */}
                        <div className="flex items-center gap-4 mt-4">
                            <div className="flex -space-x-2">
                                {[0, 1, 2].map((i) => (
                                    <div
                                        key={i}
                                        style={{ ...shimmer, height: 32, width: 32, borderRadius: "50%" }}
                                    />
                                ))}
                            </div>
                            <div style={{ ...shimmer, height: 18, width: 260 }} />
                        </div>
                    </div>

                    {/* Right column — card skeleton */}
                    <div
                        className="lg:col-span-5"
                        style={{ ...shimmer, height: 500, borderRadius: "2rem" }}
                    />
                </div>
            </section>
        </>
    );
}
